 
export default function Style(){
  return (
    <style>
      {`
        .blogsSlider .slick-list .slick-track .slick-slide {
          width: 293px !important;
            height: 346px !important;
        }
        .lh-27{
            line-height: 27px !important;
        }
        /* //.blogsSlider .left-arrow{
             
        //       left: -25px !important;
              
        // }
        // .blogsSlider .right-arrow {
        
        //   right: -36px !important;
           
        // } */
        
         
        
        
         .blogsSlider .left-arrow{
          left: -32px;
          color: black;
          outline: none;
          position: absolute;
          top: 43%;
          z-index: 1;
        }
         .blogsSlider .right-arrow {
          right: -41px ;
          color: black;
          outline: none;
          position: absolute;
          top: 43%;
          z-index: 1;
        }
         
         
         .blogsSlider .left-arrow .right-arrow {
           font-size: 0;
           line-height: 0;
           position: absolute;
          display: block;
          width: 20px;
          height: 20px;
          padding: 0;
              -webkit-transform: translate(0, -50%);
              -moz-transform: translate(0, -50%);
              transform: translate(0, -50%);
              cursor: pointer;
              color: transparent;
              border: none;
              outline: none;
              background: transparent;
        }
         .blogsSlider .left-arrow:hover {
          color: black!important;
        
        }
         .blogsSlider .right-arrow:hover {
          color: black !important;
        
        }
        
        
        
        @media only screen and (max-width: 390px){
          .blogsSlider .slick-list .slick-track .slick-slide {
              width: 246px !important;
          }
        }
        
        
        @media (max-width: 1534px) {
          .fs-14-16 {
            font-size: 14px !important; 
          }
        
          .fs-22-24 {
            font-size: 22px !important;
            line-height: 25px !important;
          }
        
          .fs-16-16 {
            font-size: 16px !important; 
          }
        }
        
        @media (min-width: 1543px) {
          .fs-14-16 {
            font-size: 16px !important; 
          }
        
          .fs-22-24 {
            font-size: 24px !important;
            line-height: 27px !important;
          }
        
          .fs-16-16 {
            font-size: 17px !important; 
          }
        }
        

        `}
    </style>
  );
}
